const key = 'dismissedCookieNotice'

export const getCookieConsent = (): boolean => {
  return localStorage.getItem(key) === 'true'
}

export const setCookieConsent = (value: boolean): void => {
  localStorage.setItem(key, value.toString())
}
